export default __webpack_public_path__ + "static/media/glo.9e186a25.svg";